import React, { Component } from "react";

interface Props {
  onPage: (p: number) => void;
  count?: number;
}

export class PaginationOffset extends Component<Props | any> {
  query = new URLSearchParams(this.props.location.search);

  constructor(props: any) {
    super(props);
    if (!this.query.get("page")) {
      this.query.append("page", "1");
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: this.query.toString(),
      });
    }

    this.props.onPage(Number(this.query.get("page")));

    this.handleNext = this.handleNext.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.onListQuery = this.onListQuery.bind(this);
  }

  handleKeyPress = (e: any) => {
    if (e.which === 13) {
      e.preventDefault();
      this.query.set("page", Number(e.target.innerText) > 0 ? e.target.innerText : "1");
      e.target.innerText = this.query.get("page");
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: this.query.toString(),
      });
      this.props.onPage(Number(this.query.get("page")));
    }
  };

  handleBlur = (e: any) => {
    this.query.set("page", Number(e.target.innerText) > 0 ? e.target.innerText : "1");
    e.target.innerText = this.query.get("page");
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: this.query.toString(),
    });
    this.props.onPage(Number(this.query.get("page")));
  };

  handleNext() {
    this.query.set("page", String(Number(Number(this.query.get("page")) === 0 ? "1" : this.query.get("page")) + 1));
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: this.query.toString(),
    });
    this.props.onPage(Number(this.query.get("page")));
  }

  handlePrevious() {
    this.query.set("page", String(Number(this.query.get("page")) - 1));
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: this.query.toString(),
    });
    this.props.onPage(Number(this.query.get("page")));
  }

  onListQuery = () => {
    this.props.history.listen((res: any) => {
      const q = new URLSearchParams(res.search);
      this.query = q;
    });
  };

  componentDidMount() {
    this.onListQuery();
  }

  render() {
    return (
      <ul className="pagination" style={{ margin: 0, justifyContent: "flex-end" }}>
        <li
          className={`paginate_button page-item previous ${
            this.query.get("page") === "1" || this.query.get("page") === null ? "disabled" : ""
          }`}
        >
          <button className="page-link" onClick={this.handlePrevious}>
            Previous
          </button>
        </li>
        <li className="paginate_button page-item ">
          <div
            className="page-link"
            onBlur={this.handleBlur}
            onKeyPress={this.handleKeyPress}
            contentEditable
            style={{ cursor: "auto" }}
            data-text={this.query.get("page") || "1"}
          ></div>
        </li>
        {this.props.count !== undefined ? (
          <li
            className={`paginate_button page-item next ${
              this.props.count < Number(this.query.get("limit") || 0) ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={this.handleNext}>
              Next
            </button>
          </li>
        ) : (
          <li className={`paginate_button page-item next`}>
            <button className="page-link" onClick={this.handleNext}>
              Next
            </button>
          </li>
        )}
      </ul>
    );
  }
}
